if (!customElements.get('ly-main-product-form-activity-countdown-counter')) {
    customElements.define('ly-main-product-form-activity-countdown-counter', class extends HTMLElement {
        connectedCallback() {
            this.endDate = this.getAttribute('data-end-date')
            if (!this.endDate) return

            this.update()
            this.timer = setInterval(() => this.update(), 1000)
        }

        disconnectedCallback() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }

        update() {
            let target = new Date(this.endDate).getTime()
            const now = Date.now()

            // 如果已过时，向后推一周，直到目标时间在未来
            while (target <= now) {
                target += 7 * 24 * 60 * 60 * 1000
            }

            // 更新 data-end-date 属性，保证刷新页面时状态不丢失
            this.setAttribute('data-end-date', new Date(target).toISOString().slice(0, 19))

            const diff = target - now
            const totalSec = Math.floor(diff / 1000)

            const days = `${Math.floor(totalSec / 86400)}`.padStart(2, '0')
            const hours = `${Math.floor((totalSec % 86400) / 3600)}`.padStart(2, '0')
            const minutes = `${Math.floor((totalSec % 3600) / 60)}`.padStart(2, '0')
            const seconds = `${totalSec % 60}`.padStart(2, '0')

            this.textContent = `${days} : ${hours} : ${minutes} : ${seconds}`
        }
    })
}